<asociaciones-buscador [mios]="mios"></asociaciones-buscador>
<loading-layout #loadingLayout>
    <table-with-actions [contentArray]="asociaciones" [showParams]="params" [tableButtonsArray]="tableButtonsArray">
    </table-with-actions>
</loading-layout>
<paginator #paginator [getList]="this.showAll.bind(this)"></paginator>